export default {
  input_nit: {
    label: '{typeDoc}:',
    placeholder: 'Ingresa un {typeDoc} | Ingresa una {typeDoc}',
    error: {
      required: 'El campo de {typeDoc} es requerido | El campo de {typeDoc} es requerida',
      format: 'Debe especificar un {typeDoc} válido | Debe especificar una {typeDoc} válida'
    }
  }
}
